export const HRS_KEYS = ["hr3", "hr2", "hr1"];
export const HRS = {
  hr1: "歩行レベル",
  hr2: "有酸素",
  hr3: "最大",
};
